module.exports = __webpack_public_path__ + "img/btn.00988199.png";